import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  ReCaptchaV3Provider,
  // getToken,
  initializeAppCheck,
} from "firebase/app-check";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIRE_BASE_API_KEY,
  authDomain: process.env.REACT_APP_FIRE_BASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIRE_BASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIRE_BASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIRE_BASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIRE_BASE_APP_ID,
  measurementId: process.env.REACT_APP_FIRE_BASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

let appCheck = null;
// let appCheckToken = null;

(async () => {
  const initAppCheck = async () => {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(
        process.env.REACT_APP_RECAPTCHA_SITE_KEY,
      ),
      isTokenAutoRefreshEnabled: true,
    });

    // const appCheckTokenResponse = await getToken(appCheck, true);

    // appCheckToken = appCheckTokenResponse.token;
    // console.log({appCheckToken})
  };
  await initAppCheck();
})();

export {
  db,
  appCheck,
  // appCheckToken
};
